import { createContext } from 'react';

import type { ColorTheme } from './types';

export const ThemeContext = createContext<ColorTheme>('light');
